module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg9-7a9afb48c661f8fd3c391241a53b95ec.jpg";